import React, { useState, useEffect } from 'react';
import './Home.css';
import { db } from '../firebaseConfig';
import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
import TypewriterSlogan from './TypewriterSlogan';
import logo from '../img/bazurtologo.png';
import PromotionBanner from './PromotionBanner';

function Home({ isScrolled }) {
  const [heroImageUrl, setHeroImageUrl] = useState('');
  const [heroVideoUrlMobile, setHeroVideoUrlMobile] = useState('');
  const [heroVideoUrlDesktop, setHeroVideoUrlDesktop] = useState('');
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [popupPromotion, setPopupPromotion] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);

    const fetchContent = async () => {
      setLoading(true);
      try {
        // Fetch Hero Content
        const heroDocRef = doc(db, 'siteContent', 'hero');
        const heroDocSnap = await getDoc(heroDocRef);
        if (heroDocSnap.exists()) {
          const data = heroDocSnap.data();
          setHeroImageUrl(data.imageUrl || '');
          setHeroVideoUrlMobile(data.videoUrlMobile || '');
          setHeroVideoUrlDesktop(data.videoUrlDesktop || '');
        }

        // Fetch popup promotion
        const q = query(collection(db, "promotions"), where("isPopup", "==", true));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const promoData = querySnapshot.docs[0].data();
          const promoId = querySnapshot.docs[0].id;
          setPopupPromotion({ id: promoId, ...promoData });
        }

      } catch (error) {
        console.error('Error al obtener contenido desde Firestore:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run only once on mount

  useEffect(() => {
    // Timer to show the banner after a delay, only once per session
    if (popupPromotion && !sessionStorage.getItem('bannerShown')) {
      const timer = setTimeout(() => {
        setShowBanner(true);
        sessionStorage.setItem('bannerShown', 'true');
      }, 3000); // 3-second delay

      return () => {
        clearTimeout(timer);
      };
    }
  }, [popupPromotion]); // Run this effect when popupPromotion is set

  if (loading) {
    return (
      <section 
        id="home" 
        className="home-section"
      >
        <div className="home-content">
          <h1 className="home-title">Cargando...</h1>
        </div>
      </section>
    );
  }

  const renderHeroContent = () => {
    if (isMobile) {
      if (heroVideoUrlMobile) {
        return <video className="home-video" src={heroVideoUrlMobile} autoPlay loop muted playsInline />;
      }
    } else {
      if (heroVideoUrlDesktop) {
        return <video className="home-video" src={heroVideoUrlDesktop} autoPlay loop muted playsInline />;
      }
    }
    // Fallback to image if the specific video is not available
    if (heroImageUrl) {
      return <img className="home-image" src={heroImageUrl} alt="Yo Amo Bazurto Hero" />;
    }
    // Fallback if no content is configured
    return (
      <div style={{ backgroundColor: '#f0f0f0', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <p>No hay contenido de hero configurado.</p>
      </div>
    );
  };

  return (
    <section 
      id="home" 
      className="home-section"
    >
      {renderHeroContent()}
      <div className="home-content">
        <img 
          src={logo} 
          alt="Yo Amo Bazurto Logo" 
          className={`hero-logo ${isScrolled ? 'hidden' : ''}`} 
        />
        <p className={`home-subtitle ${isScrolled ? 'hidden' : ''}`}><TypewriterSlogan text="Puro sabor efectivo" delay={150} /></p>
      </div>
      {showBanner && popupPromotion && (
        <PromotionBanner 
          promotion={popupPromotion}
          onClose={() => setShowBanner(false)} 
        />
      )}
    </section>
  );
}

export default Home;